import { LoginInput, SignUpForm, TokenData } from '@/types'

import { api } from '.'

export const loginUserFn = async (values: LoginInput): Promise<TokenData> => {
  const { data } = await api.post<TokenData>('/user/auth', values, {
    withCredentials: process.env.NODE_ENV === 'production',
  })

  return data
}

export const googleAuthFn = async (values: any): Promise<TokenData> => {
  const { data } = await api.post<TokenData>(
    '/user/auth/googleAuth',
    {
      ...values,
      r: window.localStorage.getItem('r') || undefined,
    },
    { withCredentials: process.env.NODE_ENV === 'production' }
  )

  return data
}

export const telegramAuthFn = async (values: any): Promise<TokenData> => {
  const rValue = 'r' in values ? values.r : window.localStorage.getItem('r') || undefined;

  const { data } = await api.post<TokenData>(
    '/user/auth/telegramAuth',
    {
      ...values,
      r: rValue,
    },
    { withCredentials: process.env.NODE_ENV === 'production' }
  )

  return data
}

export const discordAuthFn = async (values: any): Promise<TokenData> => {
  const { data } = await api.post<TokenData>(
    '/user/auth/discordAuth',
    {
      ...values,
      r: window.localStorage.getItem('r') || undefined,
    },
    { withCredentials: process.env.NODE_ENV === 'production' }
  )

  return data
}

export const solanaAuthFn = async (values: any): Promise<TokenData> => {
  const { data } = await api.post<TokenData>(
    '/user/auth/solanaAuth',
    {
      ...values,
      r: window.localStorage.getItem('r') || undefined,
    },
    { withCredentials: process.env.NODE_ENV === 'production' }
  )

  return data
}

export const metamaskAuthFn = async (values: any): Promise<TokenData> => {
  const { data } = await api.post<TokenData>(
    '/user/auth/metamaskAuth',
    {
      ...values,
      r: window.localStorage.getItem('r') || undefined,
    },
    { withCredentials: process.env.NODE_ENV === 'production' }
  )

  return data
}

// TODO: return type
export const signUpUserFn = async (values: SignUpForm): Promise<any> => {
  const { data } = await api.post<TokenData>('/user/signup', {
    ...values,
    r: window.localStorage.getItem('r') || undefined,
  })

  return data
}

export const validEmailTokenFn = async (values: {
  emailToken: string
}): Promise<TokenData> => {
  const { data } = await api.post<TokenData>(`/user/validEmailToken`, values)

  return data
}

export const sendForgotPasswordEmailFn = async (values: {
  email: string
}): Promise<TokenData> => {
  const { data } = await api.post<TokenData>(
    `/user/sendForgotPasswordEmail`,
    values
  )

  return data
}

export const setNewPasswordEmailFn = async (values: {
  password: string
  resetPasswordCode: string
}): Promise<TokenData> => {
  const { data } = await api.post<TokenData>(`/user/setNewPassword`, values)

  return data
}
